import { useState, useEffect, memo, useCallback } from "react";
import AnimacionCarga from "./animacion_de_carga";
import FiltrosTarjetas, { aplicarFiltrosTarjetas } from "./filtros_tarjetas";
import TablaGenerica from "./tablas";
import BotonFlotante from "./BotonFlotante";
import { obtenerClientes } from "../../functions/consultas";
import Swal from "sweetalert2";
import { crearRegistro, actualizarRegistro } from "../../functions/crud";

const COLUMNAS = [
  { label: "Id", key: "id" },
  { label: "Razón Social", key: "Nombre" },
  { label: "NIT", key: "Nit" },
  { label: "Ciudad", key: "Ciudad" },
  { label: "Administrador", key: "NombreAdministrador" },
  { label: "Correo", key: "correoElectronico" },
  { label: "Teléfono", key: "TelefonoAdministrador" },
  { label: "Estado", key: "estado" },
  { label: "Vencimiento", key: "vencimiento" },
  { label: "Días", key: "diasRestantes" },
];

const calcularDiasRestantes = (vencimiento) => {
  if (!vencimiento) return null;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const fechaVencimiento = new Date(vencimiento);
  fechaVencimiento.setHours(0, 0, 0, 0);
  if (isNaN(fechaVencimiento)) return null;
  return Math.round((fechaVencimiento - hoy) / (1000 * 60 * 60 * 24));
};

const ListadoClientes = memo(() => {
  const [datos, setDatos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtros, setFiltros] = useState({});

  const capturarDatos = useCallback(async () => {
    try {
      const data = await obtenerClientes();
      const lista = Array.isArray(data) ? data : Object.values(data || {});
      setDatos(lista.map((c) => ({ ...c, diasRestantes: calcularDiasRestantes(c.vencimiento) })));
    } catch (error) {
      console.error("Error al obtener clientes:", error);
    } finally {
      setCargando(false);
    }
  }, []);

  const generarFormularioCrear = () => `
    <style>
      .swal2-input, .swal2-select {
        margin: 0 !important;
        width: 100% !important;
        box-sizing: border-box !important;
        padding: 10px !important;
        border: 1px solid #d1d5db !important;
        border-radius: 5px !important;
        font-size: 14px !important;
      }
    </style>
    <div style="text-align:left;padding:20px;">
      <h3 style="margin:0 0 25px;color:#2c3e50;font-size:20px;font-weight:600;">
        Nuevo Cliente
      </h3>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Razón Social</label>
        <input id="nombre" class="swal2-input" placeholder="Nombre del cliente">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">NIT</label>
        <input id="nit" type="number" class="swal2-input" placeholder="Número de identificación">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Correo Electrónico</label>
        <input id="correo" type="email" class="swal2-input" placeholder="correo@ejemplo.com">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Nombre Administrador</label>
        <input id="nombreAdmin" class="swal2-input" placeholder="Nombre del administrador">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Teléfono Administrador</label>
        <input id="telefono" type="number" class="swal2-input" placeholder="Número de teléfono">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Ciudad</label>
        <input id="ciudad" class="swal2-input" placeholder="Ciudad">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Departamento</label>
        <input id="departamento" class="swal2-input" placeholder="Departamento">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Dirección</label>
        <input id="direccion" class="swal2-input" placeholder="Dirección completa">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Control de Visitantes</label>
        <input id="controlVisitantes" class="swal2-input" placeholder="Tipo de control">
      </div>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Fecha de Vencimiento</label>
        <input id="vencimiento" type="date" class="swal2-input">
      </div>
    </div>
  `;

  const generarFormularioEditar = (cliente) => `
    <style>
      .swal2-input, .swal2-select {
        margin: 0 !important;
        width: 100% !important;
        box-sizing: border-box !important;
        padding: 10px !important;
        border: 1px solid #d1d5db !important;
        border-radius: 5px !important;
        font-size: 14px !important;
      }
    </style>
    <div style="text-align:left;padding:20px;">
      <h3 style="margin:0 0 25px;color:#2c3e50;font-size:20px;font-weight:600;">
        Editar Cliente: ${cliente.Nombre || 'Sin nombre'}
      </h3>
      
      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Estado</label>
        <select id="estado" class="swal2-select">
          <option value="AUTORIZADO" ${cliente.estado === 'AUTORIZADO' ? 'selected' : ''}>AUTORIZADO</option>
          <option value="PENDIENTE" ${cliente.estado === 'PENDIENTE' ? 'selected' : ''}>PENDIENTE</option>
          <option value="RECHAZADO" ${cliente.estado === 'RECHAZADO' ? 'selected' : ''}>RECHAZADO</option>
        </select>
      </div>

      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Fecha de Vencimiento</label>
        <input id="vencimiento" type="date" class="swal2-input" value="${cliente.vencimiento || ''}">
      </div>

      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Nombre Administrador</label>
        <input id="nombreAdmin" class="swal2-input" placeholder="Nombre del administrador" value="${cliente.NombreAdministrador || ''}">
      </div>

      <div style="margin-bottom:15px;">
        <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Teléfono Administrador</label>
        <input id="telefonoAdmin" type="number" class="swal2-input" placeholder="Número de teléfono" value="${cliente.TelefonoAdministrador || ''}">
      </div>
      
      <div style="background:#f8f9fa;padding:15px;border-radius:8px;margin-top:20px;">
        <p style="margin:0;color:#555;font-size:13px;"><strong>NIT:</strong> ${cliente.Nit || 'N/A'}</p>
        <p style="margin:5px 0 0;color:#555;font-size:13px;"><strong>Correo:</strong> ${cliente.correoElectronico || 'N/A'}</p>
      </div>
    </div>
  `;

  const validarDatosCrear = () => {
    const nombre = document.getElementById("nombre").value.trim();
    const nit = document.getElementById("nit").value.trim();
    const correo = document.getElementById("correo").value.trim();
    const nombreAdmin = document.getElementById("nombreAdmin").value.trim();
    const telefono = document.getElementById("telefono").value.trim();
    const ciudad = document.getElementById("ciudad").value.trim();
    const departamento = document.getElementById("departamento").value.trim();
    const direccion = document.getElementById("direccion").value.trim();
    const controlVisitantes = document.getElementById("controlVisitantes").value.trim();
    const vencimiento = document.getElementById("vencimiento").value;

    if (!nombre) {
      Swal.showValidationMessage("La razón social es obligatoria");
      return false;
    }
    if (!nit) {
      Swal.showValidationMessage("El NIT es obligatorio");
      return false;
    }
    if (!correo) {
      Swal.showValidationMessage("El correo electrónico es obligatorio");
      return false;
    }
    if (!nombreAdmin) {
      Swal.showValidationMessage("El nombre del administrador es obligatorio");
      return false;
    }
    if (!vencimiento) {
      Swal.showValidationMessage("La fecha de vencimiento es obligatoria");
      return false;
    }

    return {
      nombre,
      nit: parseInt(nit),
      correo,
      nombreAdmin,
      telefono: telefono ? parseInt(telefono) : null,
      ciudad,
      departamento,
      direccion,
      controlVisitantes,
      vencimiento,
    };
  };

  const crearCliente = useCallback(async () => {
    const { value: formValues } = await Swal.fire({
      title: "Crear Cliente",
      html: generarFormularioCrear(),
      showCancelButton: true,
      confirmButtonText: "Crear",
      cancelButtonText: "Cancelar",
      width: 600,
      preConfirm: validarDatosCrear,
    });

    if (!formValues) return;

    try {
      const clienteData = {
        logo: null,
        correoElectronico: formValues.correo,
        RazonSocial: formValues.nombre,
        Nombre: formValues.nombre,
        NombreAdministrador: formValues.nombreAdmin,
        Nit: formValues.nit,
        TelefonoAdministrador: formValues.telefono,
        Ciudad: formValues.ciudad,
        Direccion: formValues.direccion,
        Departamento: formValues.departamento,
        controlVisitantes: formValues.controlVisitantes,
        vencimiento: formValues.vencimiento,
        estado: "AUTORIZADO",
        horaInicioAtencion: "07:00",
        horaFinalAtencion: "17:00",
        moduloVisitantes: true,
        moduloEncomiendas: true,
        moduloReservas: true,
        moduloPagos: true,
        moduloPqrs: true,
        moduloAnuncios: true,
        moduloPanico: false,
        correoMonitoreo: "monitoreo@coordinarseguridad.com",
      };

      const resultado = await crearRegistro(`coordi_ph_clientes/${formValues.nit}/`, clienteData);
      await actualizarRegistro(`coordi_ph_clientes/${formValues.nit}/${resultado}/id`, resultado);
      await actualizarRegistro(`clientes/${formValues.nit}`, resultado);

      Swal.fire("Éxito", "Cliente creado correctamente", "success");
      capturarDatos();
    } catch (error) {
      console.error("Error al crear cliente:", error);
      Swal.fire("Error", "No se pudo crear el cliente", "error");
    }
  }, [capturarDatos]);

  const editarCliente = useCallback(async (cliente) => {
    const { value: formValues } = await Swal.fire({
      title: "Editar Cliente",
      html: generarFormularioEditar(cliente),
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      width: 600,
      preConfirm: () => {
        const estado = document.getElementById("estado").value;
        const vencimiento = document.getElementById("vencimiento").value;
        const nombreAdmin = document.getElementById("nombreAdmin").value.trim();
        const telefonoAdmin = document.getElementById("telefonoAdmin").value.trim();

        if (!vencimiento) {
          Swal.showValidationMessage("La fecha de vencimiento es obligatoria");
          return false;
        }
        if (!nombreAdmin) {
          Swal.showValidationMessage("El nombre del administrador es obligatorio");
          return false;
        }

        return { estado, vencimiento, nombreAdmin, telefonoAdmin };
      },
    });

    if (!formValues) return;

    try {
      await actualizarRegistro(
        `coordi_ph_clientes/${cliente.Nit}/${cliente.id}/estado`,formValues.estado,

      );

      await actualizarRegistro(
        `coordi_ph_clientes/${cliente.Nit}/${cliente.id}/fecha_vencimiento`,formValues.vencimiento,

      );

      await actualizarRegistro(
        `coordi_ph_clientes/${cliente.Nit}/${cliente.id}/NombreAdministrador`,
        formValues.nombreAdmin
      );

      await actualizarRegistro(
        `coordi_ph_clientes/${cliente.Nit}/${cliente.id}/TelefonoAdministrador`,
        formValues.telefonoAdmin ? parseInt(formValues.telefonoAdmin) : null
      );

      Swal.fire("Éxito", "Cliente actualizado correctamente", "success");
      capturarDatos();
    } catch (error) {
      console.error("Error al actualizar cliente:", error);
      Swal.fire("Error", "No se pudo actualizar el cliente", "error");
    }
  }, [capturarDatos]);

  useEffect(() => {
    capturarDatos();
  }, [capturarDatos]);

  const normalizarClientesMasivo = useCallback(async () => {
    const CORREOS_A_REEMPLAZAR = ["sistemas@coordinarseguridad.com", "sistemas.coordinar@gmail.com", "cristian.j@coordinarseguridad.com", "coordinador.desarrollo@coordinarseguridad.com"];
    const CORREO_DESTINO = "servicioalcliente@coordinarseguridad.com";

    const VENCIMIENTO_DESTINO = "2030-07-16";
    const ayer = new Date();
    ayer.setDate(ayer.getDate() - 1);
    const VENCIMIENTO_RECHAZADO = ayer.toISOString().slice(0, 10);

    const cambios = datos.map((cliente) => {
      const cambio = { cliente, nombreAdminNuevo: null, telefonoNuevo: null, direccionNueva: null, correoNuevo: null, departamentoNuevo: null, ciudadNueva: null, vencimientoNuevo: null };

      const nombreActual = cliente.NombreAdministrador || "";
      const telefonoActual = String(cliente.TelefonoAdministrador ?? "").trim();
      const contieneJorge = nombreActual.toLowerCase().includes("jorge");
      const esRobayo = nombreActual.toLowerCase().includes("robayo") && telefonoActual === "3017980597";

      const nombreDestino = (contieneJorge || esRobayo) ? "COORDINAR SEGURIDAD" : nombreActual.toUpperCase();
      if (nombreDestino !== nombreActual) cambio.nombreAdminNuevo = nombreDestino;

      if (esRobayo) {
        if (telefonoActual !== "6063447595") cambio.telefonoNuevo = "6063447595";
      } else if (telefonoActual === "3044540386" || telefonoActual === "0" || telefonoActual === "") {
        if (telefonoActual !== "6063447575") cambio.telefonoNuevo = "6063447575";
      }

      const direccionActual = cliente.Direccion || "";
      const direccionMayus = direccionActual.toUpperCase();
      if (direccionMayus !== direccionActual) cambio.direccionNueva = direccionMayus;

      const correoActual = (cliente.correoElectronico || "").trim().toLowerCase();
      if (CORREOS_A_REEMPLAZAR.includes(correoActual) && correoActual !== CORREO_DESTINO) {
        cambio.correoNuevo = CORREO_DESTINO;
      }

      const departamentoActual = cliente.Departamento || "";
      const departamentoMayus = departamentoActual.toUpperCase();
      if (departamentoMayus !== departamentoActual) cambio.departamentoNuevo = departamentoMayus;

      const ciudadActual = cliente.Ciudad || "";
      let ciudadDestino;
      if (departamentoMayus === "CUNDINAMARCA") {
        ciudadDestino = "BOGOTÁ";
      } else if (departamentoMayus === "RISARALDA") {
        ciudadDestino = "PEREIRA";
      } else {
        ciudadDestino = ciudadActual.toUpperCase();
      }
      if (ciudadDestino !== ciudadActual) cambio.ciudadNueva = ciudadDestino;

      if (cliente.estado === "AUTORIZADO" && cliente.vencimiento !== VENCIMIENTO_DESTINO) {
        cambio.vencimientoNuevo = VENCIMIENTO_DESTINO;
      } else if (cliente.estado === "RECHAZADO" && cliente.vencimiento !== VENCIMIENTO_RECHAZADO) {
        cambio.vencimientoNuevo = VENCIMIENTO_RECHAZADO;
      }

      return cambio;
    }).filter((c) => c.nombreAdminNuevo !== null || c.telefonoNuevo !== null || c.direccionNueva !== null || c.correoNuevo !== null || c.departamentoNuevo !== null || c.ciudadNueva !== null || c.vencimientoNuevo !== null);

    if (cambios.length === 0) {
      Swal.fire("Sin cambios", "No hay registros que requieran actualización.", "info");
      return;
    }

    const filasHtml = cambios.map((c) => `
      <tr>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">${c.cliente.Nombre || c.cliente.Nit}</td>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">
          ${c.nombreAdminNuevo !== null
            ? `<span style="color:#c0392b;">${c.cliente.NombreAdministrador || "-"}</span> → <strong>${c.nombreAdminNuevo}</strong>`
            : "-"}
        </td>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">
          ${c.telefonoNuevo !== null
            ? `<span style="color:#c0392b;">${c.cliente.TelefonoAdministrador ?? "-"}</span> → <strong>${c.telefonoNuevo}</strong>`
            : "-"}
        </td>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">
          ${c.direccionNueva !== null
            ? `<span style="color:#c0392b;">${c.cliente.Direccion || "-"}</span> → <strong>${c.direccionNueva}</strong>`
            : "-"}
        </td>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">
          ${c.correoNuevo !== null
            ? `<span style="color:#c0392b;">${c.cliente.correoElectronico || "-"}</span> → <strong>${c.correoNuevo}</strong>`
            : "-"}
        </td>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">
          ${c.departamentoNuevo !== null
            ? `<span style="color:#c0392b;">${c.cliente.Departamento || "-"}</span> → <strong>${c.departamentoNuevo}</strong>`
            : "-"}
        </td>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">
          ${c.ciudadNueva !== null
            ? `<span style="color:#c0392b;">${c.cliente.Ciudad || "-"}</span> → <strong>${c.ciudadNueva}</strong>`
            : "-"}
        </td>
        <td style="padding:6px 8px;border-bottom:1px solid #eee;">
          ${c.vencimientoNuevo !== null
            ? `<span style="color:#c0392b;">${c.cliente.vencimiento || "-"}</span> → <strong>${c.vencimientoNuevo}</strong>`
            : "-"}
        </td>
      </tr>
    `).join("");

    const { isConfirmed } = await Swal.fire({
      title: `Se van a actualizar ${cambios.length} cliente(s)`,
      html: `
        <div style="text-align:left;max-height:400px;overflow-y:auto;">
          <table style="width:100%;border-collapse:collapse;font-size:12px;">
            <thead>
              <tr style="background:#f8f9fa;">
                <th style="padding:6px 8px;text-align:left;">Cliente</th>
                <th style="padding:6px 8px;text-align:left;">Administrador</th>
                <th style="padding:6px 8px;text-align:left;">Teléfono</th>
                <th style="padding:6px 8px;text-align:left;">Dirección</th>
                <th style="padding:6px 8px;text-align:left;">Correo</th>
                <th style="padding:6px 8px;text-align:left;">Departamento</th>
                <th style="padding:6px 8px;text-align:left;">Ciudad</th>
                <th style="padding:6px 8px;text-align:left;">Vencimiento</th>
              </tr>
            </thead>
            <tbody>${filasHtml}</tbody>
          </table>
        </div>
      `,
      width: 1000,
      showCancelButton: true,
      confirmButtonText: "Aplicar cambios",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#c0392b",
    });

    if (!isConfirmed) return;

    try {
      for (const c of cambios) {
        const ruta = `coordi_ph_clientes/${c.cliente.Nit}/${c.cliente.id}`;
        if (c.nombreAdminNuevo !== null) {
          await actualizarRegistro(`${ruta}/NombreAdministrador`, c.nombreAdminNuevo);
        }
        if (c.telefonoNuevo !== null) {
          await actualizarRegistro(`${ruta}/TelefonoAdministrador`, parseInt(c.telefonoNuevo));
        }
        if (c.direccionNueva !== null) {
          await actualizarRegistro(`${ruta}/Direccion`, c.direccionNueva);
        }
        if (c.correoNuevo !== null) {
          await actualizarRegistro(`${ruta}/correoElectronico`, c.correoNuevo);
        }
        if (c.departamentoNuevo !== null) {
          await actualizarRegistro(`${ruta}/Departamento`, c.departamentoNuevo);
        }
        if (c.ciudadNueva !== null) {
          await actualizarRegistro(`${ruta}/Ciudad`, c.ciudadNueva);
        }
        if (c.vencimientoNuevo !== null) {
          await actualizarRegistro(`${ruta}/vencimiento`, c.vencimientoNuevo);
        }
      }

      Swal.fire("Éxito", `Se actualizaron ${cambios.length} cliente(s) correctamente`, "success");
      capturarDatos();
    } catch (error) {
      console.error("Error en normalización masiva:", error);
      Swal.fire("Error", "Ocurrió un error durante la actualización masiva", "error");
    }
  }, [datos, capturarDatos]);

  if (cargando) return <AnimacionCarga />;

  return (
    <div className="tabla-clientes-compacta">
      <style>{`
        .tabla-clientes-compacta .tabla-responsive th,
        .tabla-clientes-compacta .tabla-responsive td { padding: 4px 5px; }
        .tabla-clientes-compacta .tabla-responsive { font-size: 0.62rem; table-layout: auto; }
      `}</style>
      <TablaGenerica
        datos={aplicarFiltrosTarjetas(datos, filtros)}
        contenidoExtra={
          <div style={{ margin: "12px 0" }}>
            <FiltrosTarjetas
              datos={datos}
              grupos={[{ campo: "estado", etiqueta: "Estado" }]}
              filtros={filtros}
              setFiltros={setFiltros}
            />
          </div>
        }
        titulos={COLUMNAS.map((c) => c.label.toUpperCase())}
        campos={COLUMNAS.map((c) => c.key)}
        elementosPorPagina={3000}
        columnaOrdenInicial={0}
        direccionOrdenInicial="asc"
        botones={[
          { texto: "Editar", icono: "bi-pencil", accion: editarCliente },
        ]}
        renderizadores={{
          diasRestantes: (valor) => {
            if (valor === null || valor === undefined) return "N/A";
            const vencido = valor < 0;
            return (
              <span style={{ color: vencido ? "#c0392b" : "#27ae60", fontWeight: 600 }}>
                {vencido ? 0 : valor}
              </span>
            );
          },
        }}
      />

      <BotonFlotante
        opciones={[
          { texto: "Refrescar", icono: "🔄", accion: capturarDatos },
          { texto: "Nuevo Cliente", icono: "➕", accion: crearCliente },
        ]}
        data={aplicarFiltrosTarjetas(datos, filtros)}
        headers={COLUMNAS}
        nombreArchivo="listado_clientes"
      />
    </div>
  );
});

export default ListadoClientes;